import { Customer, Device } from '@iotv/datamodel';
import ApiGateway from '../../../data/aws/api-gateway/ApiGateway';
import config from '@iotv/config';
const dyn = config.aws.dynamoDB;
const debug = process.env.REACT_APP_DEBUG && false;
const apiRef = 'SystemManagementApi';
const TIME_DELAY = 50; //ms
export const addToDevicesInventory = async ({ user, contextCustomer, devices, progress }) => {
    const processDevice = (device) => {
        return new Promise((resolve) => {
            setTimeout(() => {
                resolve(ApiGateway.post('/system/Device/addToInventory', { contextUser: user, device, contextCustomer }, apiRef));
                progress && progress((val) => val + 1);
            }, TIME_DELAY); // Adjust the delay time as needed
        });
    };
    const result = { err: null, data: null };
    if (contextCustomer) {
        const customerClassInstance = new Customer(contextCustomer);
        if (customerClassInstance.canHaveDeviceInventory()) {
            // const promises: ErrData<ValidBusinessObject>[] = await Promise.all( devices.map( (device) => {
            // }))
            const promises = [];
            for (const device of devices) {
                const result = (await processDevice(device));
                debug && console.log('Result', result);
                if (result.err === null && result.data !== null) {
                    debug && console.log('Goes through succesfully');
                    // construct device history
                    const Key = new Device(result.data).getDeviceHistoryKey();
                }
                promises.push(result);
            }
            let successes = 0, fails = 0, errMessage = '';
            promises.forEach((deviceRes) => {
                if (deviceRes.err) {
                    fails++;
                    errMessage += `${fails !== 0 ? ', ' : ''}${deviceRes.err.message}`;
                }
                else {
                    successes++;
                }
            });
            if (fails > 0) {
                const msg = `${successes} devices processed successfully but ${fails} devices were not processed. \n${errMessage}`;
                result.err = new Error(msg);
            }
            else {
                result.data = `${successes} devices processed successfully`;
            }
        }
    }
    return result;
};
